<template>
  <div>
    <div class="fourthSectionContainer" v-if="this.langChosen === 'gr'">
      <div class="fourthSectionPart">
        <div class="fourSectionTitle">일반 정보</div>

        <ul>
          <li>보너스 적용</li>
          <li>카지노 게임</li>
          <li>공급 업체 목록</li>
          <li>자주 묻는 질문</li>
          <li>회사 소개</li>
          <li>다운로드하여 플레이하십시오.</li>
        </ul>
      </div>

      <div class="fourthSectionPart">
        <div class="fourSectionTitle">추가 정보</div>

        <ul>
          <li>개인 정보 보호 정책</li>
          <li>책임감있는 게임</li>
          <li>공정한 플레이</li>
          <li>이용 약관</li>
          <li>카지노 제휴 프로그램</li>
        </ul>
      </div>
    </div>

    <div class="fourthSectionContainer" v-else>
      <div class="fourthSectionPart">
        <div class="fourthSectionTitle">General information</div>

        <ul>
          <li>Bonus Registration</li>
          <li>Casino games</li>
          <li>List of suppliers</li>
          <li>Frequent questions</li>
          <li>About us</li>
          <li>Download and play now</li>
        </ul>
      </div>

      <div class="fourthSectionPart">
        <div class="fourthSectionTitle">More information</div>

        <ul>
          <li>Privacy Policy</li>
          <li>Responsible game</li>
          <li>Fair play</li>
          <li>Terms and conditions</li>
          <li>Casino affiliate program</li>
        </ul>
      </div>
    </div>
  </div>
</template>

<script>
export default {};
</script>

<style>
.fourthSectionContainer {
  background-color: var(--lightColor);
  color: var(--darkColor);
  padding: 30px;
  padding-bottom: 1px;
}

.fourthSectionTitle {
  font-weight: bold;
}

ul,
ul li {
  margin-top: 7px;
}

.fourthSectionPart {
  margin-bottom: 30px;
}

@media screen and (min-width: 768px) {
  .fourthSectionContainer {
    display: flex;
    justify-content: space-evenly;
  }
}
</style>
